import { addEventParam, INinjaEvent, useQueuedEventStore } from '@ninjacart/nc-events-sdk-v2';
import {
  DiscoveryCardType,
  ICardActionData,
  useProfileStore,
  KissanEventType,
} from '@ninjacart/nc-nk-store';
import { ImageOrSvg, XStack, YStack } from '@ninjacart/nc-nk-ui';
import { useRouter } from '@ninjacart/nc-nk-web-deps';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Link } from 'solito/link';
import { VideoViewCount } from './playIconwithViewCount';

interface ICattlePlayListCardProps {
  cardWidth: number;
  item: ICardActionData;
}

export function CattlePlayListCard({ cardWidth, item }: ICattlePlayListCardProps) {
  const { t } = useTranslation();
  const { push } = useRouter();
  const userProfile = useProfileStore((state) => state.userProfile);
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  const navigate = () => {
    const discoveryvideoCattleEvent: INinjaEvent = {
      name: KissanEventType.FEEDPAGE_DIS_CLICKON_VIDEOCATTLE,
      screenDetails: { screen: 'feed page cattle play list page' },
      eventParams: [
        addEventParam('subCategory', item?.content?.name),
        addEventParam('playListId', item?.content?.playlistId),
      ],
    };
    enqueue(discoveryvideoCattleEvent);
  };

  const blurhash =
    '|rF?hV%2WCj[ayj[a|j[az_NaeWBj@ayfRayfQfQM{M|azj[azf6fQfQfQIpWXofj[ayj[j[fQayWCoeoeaya}j[ayfQa{oLj?j[WVj[ayayj[fQoff7azayj[ayj[j[ayofayayayj[fQj[ayayj[ayfjj[j[ayjuayj[';

  const videoUrl = `/playListDetail/${item?.content?.seoUrl ?? item?.content?.playlistId}?type=${DiscoveryCardType.ANIMALS}`;

  return (
    <XStack onPress={navigate} justifyContent="center" padding={8}>
      <Link href={videoUrl} shallow>
        <YStack
          width={cardWidth}
          height={130}
          position="relative"
          borderRadius={12}
          overflow="hidden"
          pressStyle={{ scale: 0.98 }}
        >
          <ImageOrSvg
            height={150}
            width={cardWidth}
            fit={'contain'}
            uri={
              item?.mediaDetails?.[0]?.mediaUrl ??
              'https://tecxprts3qa.s3.amazonaws.com/1717068033918-fallback_.svg'
            }
            blurHash={blurhash}
            borderRadius={0}
          />
          <VideoViewCount item={item} />
        </YStack>
      </Link>
    </XStack>
  );
}
